import styled from 'styled-components'

import { Typography } from '@/components/ui/typography'

// Note: sits in a modal footer, pushing the buttons to the right
export const Text = styled(Typography)(() => ({
  alignSelf: 'center',
  marginRight: 'auto',
}))
